import * as tslib_1 from "tslib";
import { Status } from '@sentry/types';
/** Noop transport */
export class NoopTransport {
    /**
     * @inheritDoc
     */
    sendEvent(_) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return Promise.resolve({
                reason: `NoopTransport: Event has been skipped because no Dsn is configured.`,
                status: Status.Skipped,
            });
        });
    }
    /**
     * @inheritDoc
     */
    close(_) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return Promise.resolve(true);
        });
    }
}
//# sourceMappingURL=noop.js.map